module.exports = __webpack_public_path__ + "img/25_5.84977610.png";